// extracted by mini-css-extract-plugin
export default {"categoryHeaderName":"_1rbbf3d","categoryHeaderDescription":"_5w62zi"};